<template>
    <kgr-generic-datalist
        v-slot="{ option }"
        ref="select"
        :pre-filtered-options="members"
        :loading="loadingMembers"
        display="fullName"
        @input:typing="handleMemberSearch"
        v-on="$listeners"
    >
        <div>
            <kgr-member-contract-state-icon :state="option.contractState" />
            {{ option.fullNameAndAddress() }}
        </div>
    </kgr-generic-datalist>
</template>

<script>
import Error from '../../../../js/model/Error';
import GenericDatalist from './GenericDatalist';
import KgrMemberContractStateIcon from '../../../members/MemberContractStateIcon.vue';
import MemberRepository from '../../../../js/repository/MemberRepository';
import { debounce } from 'lodash';

export default {
    components: {
        KgrMemberContractStateIcon,
        'kgr-generic-datalist': GenericDatalist,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            error: new Error(),
            members: [],
            loadingMembers: false,
        };
    },
    methods: {
        loadMembersByName(search) {
            this.loadingMembers = true;
            this.members = [];
            MemberRepository.findAll(this.clubId, null, null, '', search).then((members) => {
                const eventProps = { members };
                this.$emit('update:members', eventProps);
                this.members = eventProps.members;
                this.loadingMembers = false;
            }).catch(() => {
                this.$notify.error('error.loadingData');
                this.loadingMembers = false;
            });
            return [];
        },
        handleMemberSearch: debounce(function (search) {
            this.loadMembersByName(search);
        }, 500),
        resetSelected() {
            this.$refs.select.selected = null;
            this.$refs.select.searchString = '';
        },
    },
};
</script>
